/* eslint-disable camelcase */
export default {
  tab_main: "Основное",
  tab_email: "E-mail",
  tab_phone: "Телефон",
  tab_password: "Пароль",
  unknown_error: "Произошла неизвестная ошибка при редактировании профиля",
};
